module.exports = __webpack_public_path__ + "img/videoposter1.af108927.jpg";